var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewbox":'0 0 ' + _vm.width + ' ' + _vm.height}},[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":_vm.radius,"stroke":_vm.strokeColor,"stroke-width":_vm.strokeWidth,"fill":_vm.fillCol}})])
}
var staticRenderFns = []

export { render, staticRenderFns }